/**
 * Translates a clipId into the URLs the AudioClipLibrary should fetch.
 * Two implementations exist:
 *   - RuntimeAudioResolver  → published path under `audio/{id}/`
 *   - EditorAudioResolver   → `/api/projects/{projectId}/audio/{id}/...`
 */
export interface AudioResolver {
  configUrl(clipId: string): string;
  clipFileUrl(clipId: string, file: string): string;
}

/**
 * Default runtime resolver. Pass a base path (typically the same `assetBase`
 * that ResourceLoader is configured with for the active scene).
 */
export class RuntimeAudioResolver implements AudioResolver {
  constructor(private readonly basePath: string = '') {}

  private base(): string {
    if (!this.basePath) return '';
    return this.basePath.endsWith('/') ? this.basePath : this.basePath + '/';
  }

  configUrl(clipId: string): string {
    return `${this.base()}audio/${encodeURIComponent(clipId)}/clip.json`;
  }

  clipFileUrl(clipId: string, file: string): string {
    return `${this.base()}audio/${encodeURIComponent(clipId)}/${file}`;
  }
}
